export const DefaultPrecision = 4;

export default {
    ['Ethereum']: [
        {
            name: 'AGT',
            precision: 2,
            address: '0x025a1b1844B2D0b7A6f42a591F8194AC0078f91C',
        },
    ],
    ['BSCTest']: [],
    ['BSC']: [],
} as {
    [key in WalletChainType]: TokenPrecisionInfo[];
};
